'use client';
import {Fragment, memo} from 'react';
import {useProducts} from '@/hooks/useProduct';
import CheckIcon from '@/components/icons/CheckIcon';
import CloseIcon from '@/components/icons/CloseIcon';
import {cn} from '@/app/utils/CN';

const Payments = () => {
  const {data} = useProducts();

  return (
    <section
      id={'payments'}
      className={'my-5 flex flex-col gap-2 items-center pt-[100px] sm:mx-2 xl:mx-0'}
    >
      {(data ?? []).map((product, idx) => (
        <Fragment key={'product-' + idx}>
          <p className={'text-6xl text-primary dark:text-secondary my-5'}>{product.name}</p>
          <div className={cn('flex justify-center gap-5', 'flex-col w-full xl:flex-row xl:w-auto')}>
            {product.prices.map((price, idp) => (
              <button
                className={cn(
                  'flex flex-col items-center hover:scale-100 xl:hover:scale-105 duration-500 p-5 rounded-2xl mx-5 xl:mx-0',
                  'bg-primary text-secondary dark:bg-secondary-dark dark:text-primary-dark'
                )}
                key={'product-' + idx + '-price-' + idp}
              >
                <p className={'font-serif text-4xl font-extrabold mb-5'}>{price?.name}</p>

                {price.features.map((feature, idf) => (
                  <p
                    key={'product-' + idx + '-feature-' + idf}
                    className={cn(
                      'flex items-center gap-2 text-secondary dark:text-primary-dark w-full',
                      {
                        'text-opacity-30 dark:text-opacity-30': !feature?.enabled,
                      }
                    )}
                  >
                    {feature?.enabled ? (
                      <CheckIcon className={'stroke-secondary dark:stroke-primary'} />
                    ) : (
                      <CloseIcon className={'stroke-secondary dark:stroke-primary opacity-30'} />
                    )}
                    <span className={'font-mono text-2xl xl:text-4xl'}>{feature.name}</span>
                  </p>
                ))}
                <p className={'text-3xl xl:text-5xl font-mono mt-5'}>
                  {price?.unit} <span className={'text-sm xl:text-xl'}>{price?.currency}</span>
                </p>
              </button>
            ))}
          </div>
        </Fragment>
      ))}
    </section>
  );
};

export default memo(Payments);
